import { FloatButton as AntFloatButton, type FloatButtonProps } from 'antd'
import { type ComponentRef, forwardRef } from 'react'

export type UiFloatButtonProps = FloatButtonProps

const UiFloatButtonComponent = forwardRef<ComponentRef<typeof AntFloatButton>, UiFloatButtonProps>(
  (props, ref) => <AntFloatButton ref={ref} {...props} />
)

UiFloatButtonComponent.displayName = 'UiFloatButton'

export const UiFloatButton = Object.assign(UiFloatButtonComponent, {
  Group: AntFloatButton.Group,
  BackTop: AntFloatButton.BackTop,
})

export default UiFloatButton
